import { memo } from 'react';

import { Color } from '@/constants/color';
import { Props } from '@/pages/Timeline/components/ConversationStatusAndTags/types';
import Badge from '@/ui/components/Badge/Badge';
import statusColor from '@/utils/statusColor';

const ConversationStatusAndTags = ({ conversation }: Props) => {
  if (!conversation) {
    return <p>No Conversation found</p>;
  }

  const { status, tags } = conversation;

  const conversationTags = tags.length ? (
    tags.map((tag) => (
      <Badge key={tag.id} color={Color.GRAY}>
        {tag.name}
      </Badge>
    ))
  ) : (
    <p>No tags</p>
  );
  const conversationStatus = status ? (
    <Badge color={statusColor[status]}>{status}</Badge>
  ) : (
    <p>No status present</p>
  );

  return (
    <>
      <div className="space-x-1 space-y-1 mb-1">
        {conversationStatus}
        {conversationTags}
      </div>
    </>
  );
};

export default memo(ConversationStatusAndTags);
